import { isLastDayOfMonth as isLastDayOfMonthFns } from 'date-fns/isLastDayOfMonth';

/**
 * 日付がその月の最終日（月末日）かどうか判定する
 *
 * date-fns の isLastDayOfMonth をそのまま利用する薄いラッパー。
 * ブラウザのローカル時間で判定する。
 */
export const isLastDayOfMonth = (date: Date): boolean => isLastDayOfMonthFns(date);
